import { ServiceLayer } from '@packages/cms-components';
import { Dialog, Image, Stack, Typography } from '@packages/shared';
import { useLayerTracking } from '@packages/modules/src/Tracking/hooks';
import { useState } from 'react';
import { useIntl } from 'react-intl';
import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData } from '@packages/gql/generated/shopping';
import { ProductHintsItemFragmentFragmentDoc } from '@packages/gql/generated/shopping/ProductHintsItemFragmentFragmentDoc';
import { useServiceLayerTracking } from '../Tracking/hooks/useServiceLayerTracking';
import { productHintsItemMessages } from './messages';

/* GraphQL */ `
  fragment ProductHintsItemFragment on Hint {
    iconUrl
    text
    serviceLayerId
  }
`;

export type ProductHintsItemProps = {
  data: FragmentType<typeof ProductHintsItemFragmentFragmentDoc>;
};
/**
 * ProductHintsCard component displays all product hints
 * */
export const ProductHintsItem = ({ data }: ProductHintsItemProps) => {
  const { iconUrl, serviceLayerId, text } = getFragmentData(
    ProductHintsItemFragmentFragmentDoc,
    data,
  );

  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const { trackViewLayer } = useLayerTracking();
  const { trackServiceLayerClick } = useServiceLayerTracking();

  const handleClick = () => {
    trackViewLayer(text);
    // handler can only be dispatched if a serviceLayerId is present
    trackServiceLayerClick(serviceLayerId!);

    setIsDialogOpen(true);
  };
  const { formatMessage } = useIntl();

  return (
    <>
      <Stack
        direction="row"
        spacing={1}
        alignItems="center"
        {...(serviceLayerId && {
          onClick: handleClick,
          role: 'button',
          sx: {
            cursor: 'pointer',
          },
        })}
      >
        <Image src={iconUrl} alt="" height={24} width={24} />
        <Typography variant="body2">{text}</Typography>
      </Stack>
      {serviceLayerId !== null && (
        <Dialog
          title={formatMessage(productHintsItemMessages.cardHeader)}
          open={isDialogOpen}
          dialogContent={<ServiceLayer serviceLayerId={serviceLayerId} />}
          handleClose={() => setIsDialogOpen(false)}
          displayTrackingProps={{ category: 'dv-service-layer-product-hints-item' }}
        />
      )}
    </>
  );
};
